
<div *ngIf="(errorMessage !='')" class="mt-5 container alert
      alert-danger " role="alert ">
    <strong>SERVER ERROR : </strong>{{errorMessage}}
  </div>

  <ng-template #newMsgTemplate>
    <div class="modal-header headerBackground">
      <h4 class="modal-title pull-left ">{{messageResponse.showTitle}}</h4>

    </div>
    <div class="modal-body ">
      <p>{{messageResponse.showText}}</p>
    </div>
    <div class="modal-footer ">
      <button *ngFor="let btn of messageResponse.showButtonText " type="button" class="btn btn-secondary btn-sm btn-round "
        (click)="exitModalAction(btn); ">{{btn.buttonText}}
      </button>
    </div>
  </ng-template>

  <div class="container-fluid">
  <!--   <div class="row" *ngIf="isAdmin">
      <div class="col-md-12">
        <button type="button" class="btn btn-primary" (click)="switchToApp()" #switchApp>COSYBackend</button>
        <button type="button" class="btn btn-primary" (click)="getRuntimeKeys()">RuntimeKeys</button>
      </div>
    </div>
   <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li *ngFor="let item of breadCrumb" class="breadcrumb-item"><a href='#' (click)="loadHistory(item.sessionID);$event.preventDefault()">{{item.title}}</a></li>
          </ol>
        </nav>
      </div>
   </div>-->
    <ngx-loading [show]="loading" [config]="{ fullScreenBackdrop: true,backdropBorderRadius: '14px' , primaryColour: '#f9f9f9',secondaryColour: '#ff9999', tertiaryColour: '#ffffff' }"></ngx-loading>
    <app-cosy-dynaeditor></app-cosy-dynaeditor>
    <app-cosy-collection></app-cosy-collection>
    <app-cosy-accessright></app-cosy-accessright>
    <div class="row" *ngFor="let row of grid?.GridLayout?.RowDefs ">
      <ng-template ngFor let-set [ngForOf]="row.Cols " let-i="index ">
        <div *ngIf="row.Cols[i].InterfaceElements.length> 0" [class]="row.Cols[i].ColWidth">

          <app-cosy-html [sessionID]="sessionID" (userActiontoProcess)="fetchIEUserAction($event)" (message)="showMessage($event)"  (switchToApp)="switchToApp($event)"
            (interfaceCommunicatorProps)="getInterfaceCommunicatorProps($event)" [viewAreaName]="row.Cols[i].ColViewAreaName"
            [ieList]="row.Cols[i].InterfaceElements" [subscriptions]="subscriptions" [viewAreaTemplateID]="row.Cols[i].ColViewAreaTemplateID"
            [downloadFile]="downloadFile" [cosyFormInit] = "uxControllerService.cosyFormInitProperties.UXControllerProperties" [breadCrumb]="breadCrumb" 
            [languageOptions]="languageOptions"  (loadHistory)="loadHistory($event)">
          </app-cosy-html>
        </div>
      </ng-template>
    </div>
  </div>